import "babel-polyfill"
import React from 'react'

const Motivation = React.createClass({
  render() {
    return (
      <div>
        <br /><br />
        <iframe width="560" height="315" src="https://www.youtube.com/embed/arj7oStGLkU" frameBorder="0" allowFullScreen></iframe>
      </div>
    )
  }
});

export default Motivation;



/** WEBPACK FOOTER **
 ** ./src/motivation.js
 **/